import { createAction } from 'redux-actions'

const NAMESPACE = 'WS::'

export const connected = createAction(NAMESPACE + 'CONNECTED')
export const disconnected = createAction(NAMESPACE + 'DISCONNECTED')
export const message = createAction(NAMESPACE + 'MESSAGE')
